import pluralize from 'pluralize';
import { every } from 'lodash';
import { update, updateModalProps } from 'actions/modal';
import store from 'store';
import PixaPrints from 'api';
import { getPrintLimitMaxMinAndObjectsLengthSync } from 'components/common/PhotoLibrary/utils';
import SceneHelper from 'utils/SceneHelper';
import { isAllImageLoaded, openModal, storeGetState } from 'utils/utils';
import { modalTypes, modes } from 'constants/index';

const INITIAL_RESPONSE_STATUS = { status: null, message: null };

const handleOrder = async () => {
  store.dispatch(update({ type: 'loading', modalProps: INITIAL_RESPONSE_STATUS }));
  try {
    await PixaPrints.orderItem();
    store.dispatch(updateModalProps({ success: true }));
  } catch (error) {
    store.dispatch(
      updateModalProps({
        success: false,
        message: error?.fakeMessage || 'Error while ordering',
        cancellable: error?.dismissible,
      }),
    );
  }
};

const openOrderModal = (warnings = []) =>
  openModal({ type: 'order', modalProps: { onConfirm: handleOrder, warnings } });

const openMorePhotosNeededModal = (printLimitMin) =>
  openModal({
    type: modalTypes.warning,
    modalProps: { message: `Minimum of ${printLimitMin} photos needed` },
  });

const openPhotosLoadingModal = () =>
  openModal({
    type: modalTypes.warning,
    modalProps: { message: 'Please wait until your photos are uploaded' },
  });

const areAllPhotosUploaded = () =>
  every(storeGetState().photos.photos, 'uploaded') ? true : !!(openPhotosLoadingModal() && false);

/**
 * Handles click on the order button using the latest state snapshot.
 */
export const handleOrderButtonClick = () => {
  const { scene, photos } = storeGetState();
  const { printLimitMin, photoCount } = getPrintLimitMaxMinAndObjectsLengthSync({ scene });
  if (printLimitMin > photoCount && scene.config.mode === modes.photoPrint) {
    openMorePhotosNeededModal(printLimitMin);
    return;
  }
  if (!areAllPhotosUploaded()) return;

  const warnings = [];
  if (!isAllImageLoaded(scene)) warnings.push('Some boxes are missing photos.');
  const lowQualityImage = SceneHelper.countLowQualityImage({ scene, photos });
  if (lowQualityImage) warnings.push(`You have ${pluralize('photo', lowQualityImage, true)} that is low resolution`);
  const countImagesWithCroppedFaces = SceneHelper.countImagesWithCroppedFaces({ scene, photos });
  if (countImagesWithCroppedFaces) {
    warnings.push(
      `You have ${pluralize('photo', countImagesWithCroppedFaces, true)} with ${
        countImagesWithCroppedFaces === 1 ? 'a ' : ''
      }cropped ${pluralize('face', countImagesWithCroppedFaces)}`,
    );
  }
  openOrderModal(warnings);
};
